module.exports = "https://www.gc-pro.gnp.com.mx/59e8ffb785df6cf7c0a007bc1bbfe0bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-back.svg
// module id = 71
// module chunks = 0 1